// @ts-nocheck
import React from 'react';
import { compose } from '../../core';
import FeedbackView from '../components/feedbackView'
import NotFound from '../../page/containers/NotFound'
// import { withToolById } from 'modules/tool/containers/ToolOperations';
import { useHistory } from 'react-router-dom';
import { withCreateFeedback } from './feedbackOperations';
import { withCreateBadgeAward } from 'modules/kudos-user/container/badgeAwardOperationFeedback';
import { getEmployeeBase64StringFromInt, getIntFromString } from 'modules/look';
import { EMPLOYEE_BY_ID_FEEDBACK } from '../graphql/employeeById.gql';
import { withApollo } from '@apollo/client/react/hoc'
import { FEEDBACK_BY_ID } from '../graphql/FeedbackById.gql';
import { ACTION_REQUIRED_FOR_FEEDBACK_COUNT } from '../graphql/SubmittedFeedback.gql';
import moment from 'moment-timezone';

const NewViewFeedbackContainer = props => {
  const { client, me } = props
  const history = useHistory();
  const typeList = ['received', 'submitted']
  const [Recipient, setRecipient] = React.useState(undefined);
  const [recipientName, setrecipientName] = React.useState(undefined);
  const [feedbackDetails, setFeedbackDetails] = React.useState();
  const [feedbackDetailsLoading, setFeedbackDetailsLoading] = React.useState(false)
  const [ai_trigger, SetAITrigger] = React.useState()
  const [feedback_action_permission, SetFeedbackActionPermission] = React.useState()
  let type = props.match.params.type;

  const getEmployeeById = async (id) => {
    let employee = getEmployeeBase64StringFromInt(id)
    try {
      const { data } = await client.query({
        query: EMPLOYEE_BY_ID_FEEDBACK,
        variables: { id: employee },
      });
      if (data?.employeeById) {
        setRecipient(data?.employeeById)
        setrecipientName(`${data?.employeeById?.user?.firstName} ${data?.employeeById?.user?.lastName}`)
      }
    } catch (e) {
      console.error(e)
    }
  }

  React.useEffect(() => {
    if (me) {
      if (me?.employee?.teamManagerEmployee?.totalCount > 0) {
        let start_date = moment().startOf("day").subtract(30, "days").utc().toISOString()
        let end_date = moment().endOf("day").utc().toISOString()
        GetActionRequiredListForFeedback({ feedbackFrom: me?.employee?.id, createdAt_Range: [start_date, end_date] })
      } else {
        SetFeedbackActionPermission({
          can_view: false,
          employee_count: 0
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me])

  const getFeedbackDetails = async (id) => {
    setFeedbackDetailsLoading(true)
    try {
      const { data } = await client.query({
        query: FEEDBACK_BY_ID,
        variables: { id: id },
        fetchPolicy: 'network-only'
      });

      if (data?.feedbackById) {
        const newFeedbackData = {
          ...data.feedbackById,
          badgeAward: {
            edges: data.feedbackById?.badgeAward ? [
              {
                node: {
                  badge: data.feedbackById?.badgeAward
                }
              }
            ]
              : []
          }
        }
        setFeedbackDetails(newFeedbackData)
      }
    } catch (e) {
      console.error(e)
    }
    setFeedbackDetailsLoading(false)
  }

  const GetActionRequiredListForFeedback = async (filter) => {
    try {
      const { data } = await client.query({
        query: ACTION_REQUIRED_FOR_FEEDBACK_COUNT,
        variables: { ...filter, first: 100 },
        fetchPolicy: 'network-only'
      });

      if (data?.me) {
        const employees = [].concat.apply([], data?.me?.employee?.teamManagerEmployee?.edges?.map(({ node }) => node?.employees?.edges?.map((i) => i?.node)))

        var setObj = new Set();
        var result = employees.reduce((acc, item) => {
          if (!setObj.has(getIntFromString(item?.id))) {
            setObj.add(getIntFromString(item?.id))
            acc.push(item)
          }
          return acc;
        }, [])
        let user_nodes = result?.filter(i => i?.feedbackReceived?.totalCount === 0)
        if (user_nodes?.length) {
          SetFeedbackActionPermission({
            can_view: true,
            employee_count: user_nodes?.length
          })
        } else {
          SetFeedbackActionPermission({
            can_view: false,
            employee_count: 0
          })
        }
      }
    } catch (e) {
    }
  }

  if (!typeList.includes(type)) {
    return (
      <>
        <NotFound></NotFound>
      </>
    )
  }
  else {
    return (
      <>
        <FeedbackView {...props}
          Recipient={Recipient} setRecipient={setRecipient}
          recipientName={recipientName} setrecipientName={setrecipientName}
          type={type} history={history}
          getEmployeeById={getEmployeeById}
          feedbackDetails={feedbackDetails} setFeedbackDetails={setFeedbackDetails}
          getFeedbackDetails={getFeedbackDetails}
          feedbackDetailsLoading={feedbackDetailsLoading} setFeedbackDetailsLoading={setFeedbackDetailsLoading}
          ai_trigger={ai_trigger}
          SetAITrigger={SetAITrigger}
          feedback_action_permission={feedback_action_permission}
        ></FeedbackView>
      </>
    );
  }
};

export default compose(withCreateFeedback, withCreateBadgeAward, withApollo)(NewViewFeedbackContainer);
